import CookiesPopup from "./CookiesPopup.js";
import DemoButton from "./DemoButton.js";
import Sliders from "./Sliders.js";
import Timer from "./Timer.js";

window.addEventListener("DOMContentLoaded", OuterElements);
window.addEventListener("load", OuterElements);
window.addEventListener("__ReloadElements__", OuterElements);

function OuterElements() {
    window.removeEventListener("DOMContentLoaded", OuterElements);
    window.removeEventListener("load", OuterElements);

    const CLS = [CookiesPopup, DemoButton, Sliders, Timer];

    for (const CL of CLS) {
        try {
            new CL();
        } catch (e) {
            console.warn(`ERROR of ${CL?.constructor?.name || CL}:`, e.message);
        }
    }
}
